import { defineMessages } from "react-intl";

export const tableHeaderMessages = defineMessages({
  active: {
    id: "app.active",
    defaultMessage: "Active",
  },
  id: {
    id: "app.id",
    defaultMessage: "ID",
  },
  sellingLocations: {
    id: "upgradeManager.table.sellingLocations",
    defaultMessage: "Locations",
  },
  notificationChannels: {
    id: "upgradeManager.table.notificationChannels",
    defaultMessage: "Notification channels",
  },
  minReleaseInDays: {
    id: "upgradeManager.table.minReleaseInDays",
    defaultMessage: "Min. release (days)",
  },
  maxReleaseInDays: {
    id: "upgradeManager.table.maxReleaseInDays",
    defaultMessage: "Max. release (days)",
  },
  minDelta: {
    id: "upgradeManager.table.minDelta",
    defaultMessage: "Min Delta",
  },
  maxDelta: {
    id: "upgradeManager.table.maxDelta",
    defaultMessage: "Max Delta",
  },
  sellingTargets: {
    id: "upgradeManager.table.sellingTargets",
    defaultMessage: "Targets",
  },
  multiple: {
    id: "upgradeManager.table.multiple",
    defaultMessage: "Multiple",
  },
  includedDates: {
    id: "upgradeManager.table.includedDates",
    defaultMessage: "Included dates",
  },
  excludedDates: {
    id: "upgradeManager.table.excludedDates",
    defaultMessage: "Excluded dates",
  },
});

export const upgradeManagerMessages = defineMessages({
  entityName: {
    id: "upgradeManager.entityName",
    defaultMessage: "Upgrade configuration",
  },
  createNew: {
    id: "upgradeManager.createNew",
    defaultMessage: "Create new",
  },
  noData: {
    id: "upgradeManager.noData",
    defaultMessage: "No data",
  },
  generalConfiguration: {
    id: "upgradeManager.generalConfiguration",
    defaultMessage: "Configuration",
  },
  active: {
    id: "upgradeManager.active",
    defaultMessage: "Active",
  },
  identifier: {
    id: "upgradeManager.identifier",
    defaultMessage: "Identifier",
  },
  sellingLocations: {
    id: "upgradeManager.sellingLocations",
    defaultMessage: "Selling locations",
  },
  notificationChannels: {
    id: "upgradeManager.notificationChannels",
    defaultMessage: "Notification channels",
  },
  propertyRecipients: {
    id: "upgradeManager.propertyRecipients",
    defaultMessage: "Upgrade recipients",
  },
  propertyRecipientsHelp: {
    id: "upgradeManager.propertyRecipients.help",
    defaultMessage: "Multiple emails can be added separated by commas",
  },
  generalActivationRules: {
    id: "upgradeManager.generalActivationRules",
    defaultMessage: "General activation rules",
  },
  generalSellingActivationRules: {
    id: "upgradeManager.generalSellingActivationRules",
    defaultMessage: "General selling activation rules",
  },
  minReleaseInDays: {
    id: "upgradeManager.table.minReleaseInDays",
    defaultMessage: "Min. release (days)",
  },
  maxReleaseInDays: {
    id: "upgradeManager.table.maxReleaseInDays",
    defaultMessage: "Max. release (days)",
  },
  minDelta: {
    id: "upgradeManager.minDelta",
    defaultMessage: "Min Delta",
  },
  maxDelta: {
    id: "upgradeManager.maxDelta",
    defaultMessage: "Max Delta",
  },
  deltaTypeMonetary: {
    id: "upgradeManager.deltaType.monetary",
    defaultMessage: "Monetary",
  },
  deltaTypePercentage: {
    id: "upgradeManager.deltaType.percentage",
    defaultMessage: "Percentage",
  },
  advancedConfiguration: {
    id: "upgradeManager.advancedConfiguration",
    defaultMessage: "Advanced configuration",
  },
  minStayInDays: {
    id: "upgradeManager.minStayInDays",
    defaultMessage: "Min. stay (days)",
  },
  maxStayInDays: {
    id: "upgradeManager.maxStayInDays",
    defaultMessage: "Max. stay (days)",
  },
  minSourceAvailability: {
    id: "upgradeManager.minSourceAvailability",
    defaultMessage: "Min. source line availability",
  },
  maxSourceAvailability: {
    id: "upgradeManager.maxSourceAvailability",
    defaultMessage: "Max. source line availability",
  },
  minUpgradeToAvailability: {
    id: "upgradeManager.minUpgradeToAvailability",
    defaultMessage: "Min. upgrade line availability",
  },
  maxUpgradeToAvailability: {
    id: "upgradeManager.maxUpgradeToAvailability",
    defaultMessage: "Max. upgrade line availability",
  },
  guarantee: {
    id: "upgradeManager.guarantee",
    defaultMessage: "Guarantee",
  },
  penalty: {
    id: "upgradeManager.penalty",
    defaultMessage: "Penalty",
  },
  guaranteeIgnore: {
    id: "upgradeManager.guarantee.ignore",
    defaultMessage: "Ignore",
  },
  guaranteeHas: {
    id: "upgradeManager.guarantee.has",
    defaultMessage: "Has guarantee",
  },
  guaranteeNo: {
    id: "upgradeManager.guarantee.no",
    defaultMessage: "No guarantee",
  },
  penaltyIgnore: {
    id: "upgradeManager.penalty.ignore",
    defaultMessage: "Ignore",
  },
  penaltyHas: {
    id: "upgradeManager.penalty.has",
    defaultMessage: "Has penalty",
  },
  penaltyNo: {
    id: "upgradeManager.penalty.no",
    defaultMessage: "No penalty",
  },
  includedDates: {
    id: "upgradeManager.includedDates",
    defaultMessage: "Included dates",
  },
  excludedDates: {
    id: "upgradeManager.excludedDates",
    defaultMessage: "Excluded dates",
  },
  promoCodes: {
    id: "upgradeManager.promoCodes",
    defaultMessage: "Promo code",
  },
  includedTags: {
    id: "upgradeManager.includedTags",
    defaultMessage: "Included tags",
  },
  targets: {
    id: "upgradeManager.targets",
    defaultMessage: "Targets",
  },
  sellingTargets: {
    id: "upgradeManager.sellingTargets",
    defaultMessage: "Targets",
  },
  newTarget: {
    id: "upgradeManager.newTarget",
    defaultMessage: "New target",
  },
  targetType: {
    id: "upgradeManager.targetType",
    defaultMessage: "Target type",
  },
  targetTypeAccommodation: {
    id: "upgradeManager.targetType.accommodation",
    defaultMessage: "Accommodation",
  },
  targetTypeMealPlan: {
    id: "upgradeManager.targetType.mealPlan",
    defaultMessage: "Meal Plan",
  },
  base: {
    id: "upgradeManager.base",
    defaultMessage: "Base",
  },
  upgradeTo: {
    id: "upgradeManager.upgradeTo",
    defaultMessage: "Upgrade to",
  },
  editTarget: {
    id: "upgradeManager.editTarget",
    defaultMessage: "Edit target",
  },
  save: {
    id: "default.save",
    defaultMessage: "Save",
  },
  back: {
    id: "app.entityForm.goBack",
    defaultMessage: "Go back",
  },
  formErrors: {
    id: "upgradeManager.formErrors",
    defaultMessage: "There are errors in the form",
  },
  updateSuccessDescription: {
    id: "app.entityForm.update.successContent",
    defaultMessage: "Upgrade configuration has been updated",
  },
  deleteConfirmTitle: {
    id: "app.entityForm.delete.confirmTitle",
    defaultMessage: "Delete configuration",
  },
  deleteConfirmContent: {
    id: "app.entityForm.delete.confirmContent",
    defaultMessage: "Are you sure you want to delete this configuration?",
  },
  seeAdvancedOptions: {
    id: "upgradeManager.seeAdvancedOptions",
    defaultMessage: "See advanced options",
  },
  hideAdvancedOptions: {
    id: "upgradeManager.hideAdvancedOptions",
    defaultMessage: "Hide advanced options",
  },
  selectOption: {
    id: "upgradeManager.selectOption",
    defaultMessage: "-- Select --",
  },
  amountPlaceholder: {
    id: "upgradeManager.amountPlaceholder",
    defaultMessage: "Amount",
  },
  currencyPlaceholder: {
    id: "upgradeManager.currencyPlaceholder",
    defaultMessage: "EUR",
  },
  percentagePlaceholder: {
    id: "upgradeManager.percentagePlaceholder",
    defaultMessage: "%",
  },
  multiSelectHelp: {
    id: "upgradeManager.multiSelectHelp",
    defaultMessage: "Hold Ctrl/Cmd to select multiple options",
  },
  noAccommodationsWarning: {
    id: "upgradeManager.noAccommodationsWarning",
    defaultMessage:
      "To select accommodations they must be created in INVENTORY > Define Inventory > Accommodations",
  },
  errorSaving: {
    id: "upgradeManager.errorSaving",
    defaultMessage: "Error saving the configuration",
  },
  errorLoading: {
    id: "upgradeManager.errorLoading",
    defaultMessage: "Error loading the configuration",
  },
  errorConflict: {
    id: "upgradeManager.errorConflict",
    defaultMessage: "A configuration already exists for this selling location",
  },
  errorConflictHelp: {
    id: "upgradeManager.errorConflictHelp",
    defaultMessage:
      "Only one upgrade configuration is allowed per selling location. To create a new configuration, you must first delete or modify the existing one.",
  },
  errorValidation: {
    id: "upgradeManager.errorValidation",
    defaultMessage: "Please fill in all required fields correctly",
  },
  errorInvalidEmails: {
    id: "upgradeManager.errorInvalidEmails",
    defaultMessage: "Invalid emails",
  },
  errorBothDates: {
    id: "upgradeManager.errorBothDates",
    defaultMessage:
      "An activation rule cannot have both included and excluded dates at the same time",
  },
  errorNoTargets: {
    id: "upgradeManager.errorNoTargets",
    defaultMessage: "At least one selling target is required to save the configuration",
  },
  addDateRange: {
    id: "upgradeManager.addDateRange",
    defaultMessage: "Add date range",
  },
  startDate: {
    id: "upgradeManager.startDate",
    defaultMessage: "Start date",
  },
  endDate: {
    id: "upgradeManager.endDate",
    defaultMessage: "End date",
  },
  actions: {
    id: "upgradeManager.actions",
    defaultMessage: "Actions",
  },
  mealPlanUpgradeMode: {
    id: "upgradeManager.mealPlanUpgradeMode",
    defaultMessage: "Upgrade mode",
  },
  mealPlanUpgradeModeExtra: {
    id: "upgradeManager.mealPlanUpgradeMode.extra",
    defaultMessage: "Extra",
  },
  mealPlanUpgradeModeInventory: {
    id: "upgradeManager.mealPlanUpgradeMode.inventory",
    defaultMessage: "Inventory",
  },
  loading: {
    id: "upgradeManager.loading",
    defaultMessage: "Loading...",
  },
  note: {
    id: "upgradeManager.note",
    defaultMessage: "Note:",
  },
  emailPlaceholder: {
    id: "upgradeManager.emailPlaceholder",
    defaultMessage: "email1@example.com, email2@example.com",
  },
});
